var MATCH = require('./_wks')('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/_fails-is-regexp.js
 ** module id = 128
 ** module chunks = 0
 **/